import { MsalAuthProvider, LoginType } from 'react-aad-msal';

const rUrl = window.location.protocol + '//' + window.location.host;
// Msal Configurations
const config = {
    auth: {
        authority: 'https://login.microsoftonline.com/d3de0d00-8a93-4045-9b9a-e19b9fbdbe2b',
        clientId: '85736f6e-8b92-4408-aa76-72f46d8c0787',
        redirectUri: rUrl
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true
    }
};  

// Authentication Parameters
const authenticationParameters = {
    scopes: [
        'api://85736f6e-8b92-4408-aa76-72f46d8c0787/Estimates'
    ]
}

// Options
const options = {
    loginType: LoginType.Redirect,
    tokenRefreshUri: window.location.origin + '/auth.html'
}

export const authProvider = new MsalAuthProvider(config, authenticationParameters, options)